import { render, staticRenderFns } from "./ImageTextElement.vue?vue&type=template&id=32adf818&"
import script from "./ImageTextElement.vue?vue&type=script&lang=js&"
export * from "./ImageTextElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports